export default "__VITE_ASSET__Bvf1Yf2P__"